import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageProjectSettings } from "@components/modules/projects/settings/PageProjectSettings";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Project settings`}
    navigation={<NavigationProjects projectId={id} />}
    scrollToTopButton
  >
    <PageProjectSettings id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/settings")({
  component: RouteComponent,
});
